import React, { useEffect, useState } from "react";
import LivePoolItemWide from "./LivePoolItemWide";
import PoolListStatus from "./PoolListStatus";
import { fetchLivePools } from "../lib/livePools";
import { programKey } from "../lib/program";

const LivePageYesterday = () => {
  const [Pools, setPools] = useState([]);
  const [PageName, setPageName] = useState("");
  const [PoolVolume, setPoolVolume] = useState(-1);
  const [UtcHour, setUtcHour] = useState(0);

  useEffect(() => {
    (async () => {
      const loadPools = async () => {
        const now = new Date();
        now.setUTCDate(now.getUTCDate() - 1);
        setUtcHour(now.getUTCHours());
        const { pools, pageName } = await fetchLivePools(now);
        setPools(pools);
        setPageName(pageName);
        setPoolVolume(pools.length);
      };
      loadPools();
      const intervalId = setInterval(() => {
        loadPools(); // Fetch data every 2 min
      }, 120000);
      return () => clearInterval(intervalId);
    })();
  }, []);

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <h1>{PageName}</h1>
        {UtcHour > 2 ? (
          <p>
            <a href="/live-pool-projections" style={{ color: "grey", fontWeight: "bold" }}>
              Show Today's Pool Projections
            </a>
          </p>
        ) : null}
        <br />
        <PoolListStatus poolVolume={PoolVolume} />
        {Pools.map((item) => (
          <React.Fragment key={programKey(item)}>
            <LivePoolItemWide item={item} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default LivePageYesterday;
